// TODO: add designs.
export const AppError = () => {
  window.location.replace(window.location.origin);
  return <>An error occured.</>;
};
